// extracted by mini-css-extract-plugin
export default {"control":"FormInput_control__EBXsy","invalid":"FormInput_invalid__svxqd","message":"FormInput_message__blDB9"};